import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export interface EmbedFormValues {
  title: string;
  url: string;
  caption: string;
}

export const embedInitialValues = (subSection: SubSection) => ({
  title: subSection?.title || "",
  url: subSection?.attrs?.url || "",
  caption: subSection?.attrs?.caption || "", // Optional
});

export const embedValidationSchema = Yup.object({
  url: Yup.string().required("Url is required"),
  caption: Yup.string().required("Caption is required"),
});
